/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';

import { SortableArrayField, ContentModuleModal } from '@molecules';

import Form from '../Form';
import BannerForm from '../BannerForm';

import { FORM_FIELDS, INITIAL_VALUES } from './constants';
import Item from './Item';
import ListItem from './ListItem';
import * as s from './styles.module.less';

const PromotionalBanner = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm();

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      form.resetFields();
      hide();
    },
    [form, hide, onSubmit],
  );

  const handleCancel = React.useCallback(() => {
    form.resetFields();
    hide();
  }, [hide, form]);

  const handleAdd = React.useCallback(
    (banner) => {
      form.setFields([
        {
          name: FORM_FIELDS.BANNERS.name,
          value: [banner, ...(form.getFieldValue(FORM_FIELDS.BANNERS.name) || [])],
        },
      ]);
    },
    [form],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Promotional banner"
      subtitle={
        <>
          Upload up to 3 images that rotate in a slideshow.
          <br />
          Images must be sized 1000px wide by 100px high and in JPG, GIF or PNG format.
        </>
      }
      okText={onDelete ? 'SAVE CHANGES' : 'ADD BANNER'}
      onCancel={handleCancel}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <BannerForm onFinish={handleAdd} />

      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
        className={s.padded}
      >
        <SortableArrayField {...FORM_FIELDS.BANNERS} form={form} withPlaceholder withCount>
          {(item) => <ListItem item={item} />}
        </SortableArrayField>
      </Form>
    </ContentModuleModal>
  );
};

PromotionalBanner.Item = Item;

export default PromotionalBanner;
